import React, { useEffect, useState } from 'react';
import { FaCheck, FaFacebook, FaInstagram, FaLinkedin } from 'react-icons/fa';
import { FiLock } from 'react-icons/fi';
import CheckboxInput from 'src/pages/DashboardPages/core/components/Forms/CheckboxInput';
import Input from '../components/Forms/Input';
import MaskedInput from '../components/Forms/MaskedInput';

import SelectSimple from '../components/Forms/SelectSimple';
import { useLanguage } from "../hooks/Language"

import api from '../services/api';
import { countries } from './SignUp/FormContainer/countries';
import states from './SignUp/FormContainer/states';

interface IProps {
    changeCountry: Function;
    countryISO: string;
    checkUserValue?: Function;
    checkUserDefault?: string;
}

export const checkDocumentNumber = async (document_number) => {

    const doc = document_number?.toString().replace(/[^0-9]/g, '');
    const valid = await api.get('check-user-document_number', { params: { document_number: doc } });

    return valid?.data?.valid || 'no';

}


const DefaultSignUpFormV4: React.FC<IProps> = ({ checkUserDefault = '', checkUserValue = (value) => { }, changeCountry }) => {

    const [countryISO, setCountryISO] = useState('BR')
    const [checkUser, setCheckUser] = useState(checkUserDefault || '')
    const [currentDocumentNumber, setCurrentDocumentNumber] = useState('');
    const { translate } = useLanguage();
    const [category, setCategory] = useState('');
    const [outro, setOutro] = useState('');
    const aha = window?.location?.pathname?.indexOf('acls-') >= 0 || window?.location?.pathname?.indexOf('acl-') >= 0 || window?.location?.pathname?.indexOf('bls-') >= 0 || window?.location?.pathname?.indexOf('pals') >= 0;


    return <>
        <SelectSimple index={1} mandatory={true} setCallback={(value) => setCountryISO(value)} options={countries} name="country" label={translate('Pais')} />


        {countryISO === 'BR' ? <MaskedInput mandatory={true}
            mask="999.999.999-99"
            name="document_number"
            setCallback={(value) => setCurrentDocumentNumber(value)}
            placeholder={translate('CPF')}
        /> : <Input setCallback={(value) => setCurrentDocumentNumber(value)} mandatory={true} name="document_number"
            placeholder={translate('Nº do documento')} />}

        {!checkUser ? <button type='button' onClick={async () => {
            const check = await checkDocumentNumber(currentDocumentNumber);


            setCheckUser(check);
            checkUserValue(check);
        }} className='greenButton2 buttonColored'>Validar</button> : <></>}
        {checkUser === 'no' ? <>
            {countryISO === 'BR' ? <SelectSimple index={2} options={states} name="state" label="Estado" /> :

                <Input name="state" placeholder={'Província / Região'} />}
            <Input name="city" placeholder={'Município'} />
            <Input mandatory={true} name="name" placeholder={translate('Nome completo')} />

            <Input name="apelido" placeholder={translate('Nome no crachá')} />




            {countryISO === 'BR' ? <MaskedInput
                mandatory={true}
                mask="(99) 99999.9999"
                name="phone"
                placeholder={translate('Telefone / Whatsapp')}
            /> : <Input name="phone" mandatory={true}
                placeholder={translate('Telefone')} />}


            {!aha ? <SelectSimple mandatory={true} setCallback={(value) => setCategory(value)} options={[
                  { label: "Assistente social", value: "Assistente social" },
                { label: "Estudante de graduação na área da saúde", value: "Estudante de graduação na área da saúde" },
                { label: "Estudante de graduação em outras áreas", value: "Estudante de graduação em outras áreas" },
                { label: "Biomédico(a)", value: "Biomédico" },
                { label: "Biólogo(a)", value: "Biólogo" },
                { label: "Enfermeiro(a)", value: "Enfermeiro" },
                { label: "Farmacêutico(a)", value: "Farmacêutico" },
                { label: "Fisioterapeuta", value: "Fisioterapeuta" },
                { label: "Fonoaudiólogo(a)", value: "Fonoaudiólogo" },
                { label: "Gestor(a) em Saúde", value: "Gestor em Saúde" },
                { label: "Médico(a)", value: "Médico" },
                { label: "Nutricionista", value: "Nutricionista" },
                { label: "Odontologista", value: "Odontologista" },
                { label: "Profissional de Educação Física", value: "Profissional de Educação Física" },
                { label: "Profissional de Informática Biomédica", value: "Profissional de Informática Biomédica" },
                { label: "Psicólogo(a)", value: "Psicólogo" },
                { label: "Sanitarista", value: "Sanitarista" },
                { label: "Terapeuta Ocupacional", value: "Terapeuta Ocupacional" },
                { label: "Outra profissão da área da saúde", value: "Outra profissão da área da saúde" },
                { label: "Minha profissão não faz parte da área da saúde", value: "Minha profissão não faz parte da área da saúde" },
            ]} name="category_id" label='Profissão' /> : <></>}

            {category === 'Médico' || category === 'Enfermeiro' ? <SelectSimple mandatory={true} label="Você é prescritor(a) de medicamentos?" options={[{ label: "Sim", value: 'Sim' }, { label: "Não", value: 'Não' }]} name="extra_2" /> : <></>}



            <MaskedInput mandatory={true}
                mask="99/99/9999"
                name="extra_1"
                placeholder={translate('Data de nascimento')}
            />

            <p style={{ fontSize: '14px', textAlign: 'center', fontWeight: 'bold', marginTop: '30px', marginBottom: '15px', color: '#333' }}> {translate('Crie seu acesso')}</p>

            <Input mandatory={true} name="email" placeholder={translate('E-mail')} />


            <Input mandatory={true}
                icon={FiLock}
                name="password"
                type="password"
                placeholder={translate('Cadastre sua senha de acesso')}
            />


            <CheckboxInput
                style={{ display: 'flex' }}
                name="inscricao_1"

                preText={(
                    <>



                    </>
                )}
                options={[
                    {
                        id: `Concordo em receber comunicação da FundMed e suas apoiadas`,
                        label: 'Concordo em receber comunicação da FundMed e suas apoiadas',
                        value: `Concordo em receber comunicação da FundMed e suas apoiadas`,
                    },

                ]}
            />

            <CheckboxInput
                style={{ display: 'flex' }}
                name="term"

                preText={(
                    <>


                    </>
                )}
                options={[
                    {
                        id: `Concordo com a política de privacidade desta plataforma`,
                        label: 'Concordo com a política de privacidade desta plataforma',
                        value: `Concordo com a política de privacidade desta plataforma`,
                    },

                ]}
            />


        </> : <></>}

        {checkUser === 'yes' ? <div className='row'><FaCheck style={{ color: 'green', fontSize: '18px' }} /> <p>Usuário identificado</p></div> : <></>}


    </>
}

export default DefaultSignUpFormV4;